import React from 'react';
import DropdownOption from './DropdownOption';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { translateResourceString } from '../../util/translationUtility';

let sortOptions = [];

class SortByDropdown extends React.Component {
    constructor(props) {
        super(props)

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };

        sortOptions = [
            new DropdownOption(translateResourceString("/Search/SortOptions/MyProducts/DisplayName"), 'MyProducts', translateResourceString("/Search/SortOptions/MyProducts/Title")),
            new DropdownOption(translateResourceString("/Search/SortOptions/NameAZ/DisplayName"), 'NameAZ', translateResourceString("/Search/SortOptions/NameAZ/Title")),
            new DropdownOption(translateResourceString("/Search/SortOptions/NameZA/DisplayName"), 'NameZA', translateResourceString("/Search/SortOptions/NameZA/Title")),
            new DropdownOption(translateResourceString("/Search/SortOptions/RecentlyAdded/DisplayName"), 'RecentlyAdded', translateResourceString("/Search/SortOptions/RecentlyAdded/Title"))
        ];
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    render() {
        const { CurrentSortBy, onCurrentSortByChange } = this.props;
        
        // Need to go through array and find when it matches
        const found = sortOptions.find(option => {
            return option.value === CurrentSortBy;
        });

        const selectedSort = found ? found : sortOptions[0];
        const title = <span><span>Sort By </span>{selectedSort.displayName} <i className="fa fa-chevron-down ml-4" /></span>;
        return (
            <Dropdown
                isOpen={this.state.dropdownOpen}
                toggle={this.toggle}
                id={`sort-by-dropdown`}
            >
                <DropdownToggle
                    className="btn btn-input"
                >
                    {title}
                </DropdownToggle>
                <DropdownMenu>
                    {sortOptions.map((option, i) => {
                        return (
                            <DropdownItem
                                key={i}
                                active={selectedSort === option}
                                onClick={() => onCurrentSortByChange(option.value)}
                            >
                                {option.displayName}
                            </DropdownItem>
                        );
                    })

                    }
                </DropdownMenu>
            </Dropdown>
        );
    }
};

SortByDropdown.propTypes = {
    CurrentSortBy: PropTypes.string,
    onCurrentSortByChange: PropTypes.func
};

export default SortByDropdown;